import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  iso: {
    width: 87,
    height: 56,
  },
  license: {
    color: '#414141',
    textAlign: 'left',
  },
  footer: {
    '& a': {
      fontSize: 14,
      lineHeight: '18px',
    },
    '@media (hover: none)': {
      '& .MuiAccordionSummary-root:hover': {
        backgroundColor: theme.palette.background.paper,
      },
      '& .MuiAccordionSummary-root:active': {
        backgroundColor: theme.palette.action.active,
      },
    },
  },
  paragraph: {
    lineHeight: '1.5',
    fontSize: '1.2em',
  },
}));
